import { render } from "./EmailEditor.vue?vue&type=template&id=4f064298&scoped=true"
import script from "./EmailEditor.vue?vue&type=script&lang=js"
export * from "./EmailEditor.vue?vue&type=script&lang=js"

import "./EmailEditor.vue?vue&type=style&index=0&id=4f064298&scoped=true&lang=css"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f064298"]])

export default __exports__